<div class="grid grid-rows-1 gap-4 m-5">
    <div class="row-start-1 lg:w-2/3 md:w-2/3 w-full justify-self-center rounded-lg">
        <div class="space-y-12 bg-white rounded-lg shadow-lg p-5">
            <div [innerHtml]="hu" class="border-b border-gray-900/10 pb-12">
                
            </div>
        </div>
    </div>
</div>